import React from 'react';
import { useSearchParams } from 'react-router-dom';
import 'Settings/angularModule';
import { angularDirectiveToReact } from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';

const SettingsDirective = angularDirectiveToReact('settings', {
    section: '<',
    page: '<',
});

export const SettingsComponent: React.FC = () => {
    const [key, params] = useAngularToReactRoute<{
        section?: string;
    }>();
    const [searchParams] = useSearchParams();
    const page = searchParams.get('page') ?? undefined;

    return <SettingsDirective key={key} {...params} page={page} />;
};
